/*
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2020-06-14 09:47:03
 * @LastEditTime: 2022-04-22 18:19:26
 * @FilePath: \raacfold\src\store.js
 */
import Vue from 'vue'
import Vuex from "vuex"
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        current_raac_id: '54_3_5',
        raac_color: ['#E77F67', '#546DE5', '#546DE5'],
        raac_shape: ['cartoon', 'cartoon', 'cartoon'],
        raac_scheme: ['KR','ANCQGHILMFPQSTVWY','DE'],
        raac_visible: [true,true, true],
        natural_seq: "MAGHLASDFAFSPPPGGGGDGPGGPEPGWVDPRTWLSFQGPPGGPGIGPGVGPGSEVWGIPPCPPPYEFCGGMAYCGPQVGVGLVPQGGLETSQPEGEAGVGVESNSDGASPEPCTVTPGAVKLEKEKLEQNPEESQDIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEEADNNENLQEICKAETLVQARKRKRTSIENRVRGNLENLFLQCPKPTLQQISHIAQQLGLEKDVVRVWFCNRRQKGKRSSSDYAQREDFEAAGSPFSGGPVSFPLAPGPHFGTPGYGSPHFTALYSSVPFPEGEAFPPVSVTTLGSPMHSN",
        raac_params: {},
        align_hits: [],
        current_protein: {},
        left_aside_width: 360,
        structure_global_setting: {},
        structure_selection_setting: {},
        global_surface_setting: {},
        selected_surface_setting: {
            'surface_color': "",
            'surface_contour': false,
            'surface_flat_shaded': false,
            'surface_metalness': 0,
            'surface_opacity': 1,
            'surface_probe_radius': 1.5,
            'surface_roughness': 1,
            'surface_scale_factor': 2,
            'surface_side': "Front",
            'surface_smooth': 20,
            'surface_type': "av",
            'surface_visual': true,
        },
        structure_resize: 0,
        features_data: {},
        selected_range:{},
        sequence_menu:{},
        raac_info:{},
        protein_uniprot: {},
        current_tool: "",
    },
    mutations: {
        currentToolMutation(state, data){
            state.current_tool = JSON.parse(JSON.stringify(data))
        },
        currentRaacIdMutation(state, data){
            state.current_raac_id = JSON.parse(JSON.stringify(data))
        },
        raacColorMutation(state, data){
            state.raac_color = JSON.parse(JSON.stringify(data))
        },
        raacSchemeMutation(state, data){
            state.raac_scheme = JSON.parse(JSON.stringify(data))
        },
        raacShapeeMutation(state, data){
            state.raac_shape = JSON.parse(JSON.stringify(data))
        },
        raacVisibleMutation(state, data){
            state.raac_visible = JSON.parse(JSON.stringify(data))
        },
        naturalSeqMutation(state, data){
            state.natural_seq = JSON.parse(JSON.stringify(data))
        },
        alignHitsMutation(state, data){
            state.align_hits = JSON.parse(JSON.stringify(data))
        },
        currentProteinMutation(state, data){
            state.current_protein = JSON.parse(JSON.stringify(data))
        },
        StructureGlobalSettingMutation(state, data){
            state.structure_global_setting = JSON.parse(JSON.stringify(data))
        },
        StructureSelectionSettingMutation(state, data){
            state.structure_selection_setting = JSON.parse(JSON.stringify(data))
        },
        GlobalSurfaceSettingMutation(state, data){
            state.global_surface_setting = JSON.parse(JSON.stringify(data))
        },
        SelectedSurfaceSettingMutation(state, data){
            state.selected_surface_setting = JSON.parse(JSON.stringify(data))
        },
        structureResizeMutation(state, data){
            state.structure_resize = JSON.parse(JSON.stringify(data))
        },
        featuresDataMutation(state, data){
            state.features_data = JSON.parse(JSON.stringify(data))
        },
        selectedRangeMutation(state, data){
            state.selected_range = JSON.parse(JSON.stringify(data))
        },
        sequenceMenuMutation(state, data){
            state.sequence_menu = JSON.parse(JSON.stringify(data))
        },
        raacInfoMutation(state, data){
            state.raac_info = JSON.parse(JSON.stringify(data))
        },
        proteinUniprotMutation(state, data){
            state.protein_uniprot = JSON.parse(JSON.stringify(data))
        },
    },
    actions: {
        getBlastResult(context, jobid) {
            let url = `${this.website}/api/align_select/${jobid}/`;
            console.log(url);
            axios.get(url).then((res) => {
                context.commit("blastResMutation", res.data.results);
            });
        },
    }
})

